import React from "react";
import { Navigate } from "react-router-dom";
import { authRoutes, invalidRoutes, dmRoutes, adminRoutes } from "./AllRoutes";
import { AuthLayout, AdminLayout, DMLayout } from "../layout";
import Page404 from "../pages/Page404";
import { routes } from "../helpers/constants";

const getRoutes = (user) => {
  const role = user ? user?.user_role : null;
  const loginRoute = localStorage.getItem("loginRoute") || routes.adminLogin;

  return [
    {
      path: routes.homepage,
      element: !user ? (
        <AuthLayout />
      ) : role === "DM" ? (
        <Navigate to={routes.dmPortal} />
      ) : (
        <Navigate to={routes.adminPortal} />
      ),
      children: authRoutes,
    },
    {
      path: routes.homepage,
      element: user ? (
        role === "DM" ? (
          <DMLayout />
        ) : (
          <AdminLayout />
        )
      ) : (
        <Navigate to={loginRoute} />
      ),
      children: user && role === "DM" ? dmRoutes : adminRoutes,
    },
    {
      path: "",
      element:
        !user && loginRoute ? (
          <Navigate to={loginRoute} />
        ) : user && role === "DM" ? (
          <Navigate to={routes.dmPortal} />
        ) : user && role === "ADMIN" ? (
          <Navigate to={routes.adminPortal} />
        ) : (
          <Page404 />
        ),
      children: invalidRoutes,
    },
  ];
};

export default getRoutes;
